import { PatientWithAccessRightDTO } from '@peartherapeutics/weaver-api-client';
import { actionTypes } from 'actions/currentPatient';

const initialState: Nullable<PatientWithAccessRightDTO> = null;

export default function patientDetails(
  state: Nullable<PatientWithAccessRightDTO> = initialState,
  action: Action<any>,
): Nullable<PatientWithAccessRightDTO> {
  switch (action.type) {
    case actionTypes.CLEAR_CURRENT_PATIENT:
      return null;
    case actionTypes.GET_PATIENT_DETAIL_SUCCESS:
      return action.payload;
    case actionTypes.SELECT_CURRENT_PATIENT:
      return action.payload;
    default:
      return state;
  }
}
